import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    invalid?: boolean;
  }
>(({ className, invalid, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 rounded-lg border-t border-[#E8E8E8]/20 bg-[#1FB3CC]/40 shadow-[inset_0px_1px_2px_0px_#0C0C2633] backdrop-blur-lg focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#1FB3CC]/80 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-white",
      className,
      invalid &&
        "border border-[#E86363] bg-[#E86363]/15 text-[#E86363] hover:border-[#E86363]"
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
